import React, {useContext, useRef, useState} from 'react';

//components
import UserContext from "../common/UserContext";
import UnassignedProductsGrid from "./AssignProducts/UnassignedProductsGrid";
import AssignedHostDelete from "./AssignProducts/AssignedHostDelete";
import AssignProductsModal from "./AssignProducts/AssignProductsModal";

//multilingual
import {
    TransportAssignDirections,
    myAssignedProductsKey,
    continueKey,
    mainMessages,
    productsHostKey,
    ProductsAvailableToAssignKey
} from "../../assets/text/MultilingualText";
import {useLocalization} from "@progress/kendo-react-intl";

//kendo
import {Button} from "@progress/kendo-react-buttons";


export default function AssignProducts(props) {
    const {
        siteLanguageDefault
    } = useContext(UserContext);
    const localization = useLocalization();

    const {
        changeStepActivation,
        setIsLoading,
        unassigned,
        setUnassigned,
        assigned,
        setAssigned,
        hostDetails,
        xAuthToken,
        showActivationCodeColumn,
        setShowActivationCodeColumn,
    } = props

    const [details, setDetails] = useState({})
    const [selectHeaderCheck, setSelectHeaderCheck] = useState(false);
    const [enableSortByDisable, setEnableSortByDisable] = useState(false)
    let sortByDisableValue = useRef(null)
    const scrollRef = useRef(null);

    const showActivationCalculation = () => {
        setShowActivationCodeColumn(unassigned.some(item => !!item.activation_code) || assigned.some(host => host.products.some(prod => !!prod.activation_code)));
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.938rem',
        }}>
            <div>
                <div className={"k-h5"}>
                    {localization.toLanguageString(productsHostKey, mainMessages[siteLanguageDefault][productsHostKey])}
                </div>
                <div style={{
                    color: '#424242',
                    fontSize: '0.875rem',
                    fontStyle: 'italic',
                }}>
                    {localization.toLanguageString(TransportAssignDirections, mainMessages[siteLanguageDefault][TransportAssignDirections])}
                </div>
            </div>

            {assigned.length !== 0 && (
                <>
                    <div
                        className={"k-h5"}
                    ref={scrollRef}
                    >
                        {localization.toLanguageString(myAssignedProductsKey, mainMessages[siteLanguageDefault][myAssignedProductsKey])}
                    </div>

                    <AssignedHostDelete
                        unassigned={unassigned}
                        setUnassigned={setUnassigned}
                        assigned={assigned}
                        setAssigned={setAssigned}
                        showActivationCodeColumn={showActivationCodeColumn}
                        setShowActivationCodeColumn={showActivationCalculation()}
                    />

                    <div style={{
                        display: 'flex',
                        justifyContent: 'end'
                    }}>
                        <Button
                            themeColor={"primary"}
                            size={"large"}
                            fillMode={"solid"}
                            type={"button"}
                            rounded={"small"}
                            onClick={() => {
                                changeStepActivation(2)
                            }}
                        >
                            {localization.toLanguageString(continueKey, mainMessages[siteLanguageDefault][continueKey])}
                        </Button>
                    </div>
                </>
            )}

            {unassigned.length !== 0 && (
                <>
                    <div className={"k-h5"}>
                        {localization.toLanguageString(ProductsAvailableToAssignKey, mainMessages[siteLanguageDefault][ProductsAvailableToAssignKey])}
                    </div>

                    <UnassignedProductsGrid
                        unassigned={unassigned}
                        setUnassigned={setUnassigned}
                        sortByDisableValue={sortByDisableValue}
                        selectHeaderCheck={selectHeaderCheck}
                        setSelectHeaderCheck={setSelectHeaderCheck}
                        enableSortByDisable={enableSortByDisable}
                        setEnableSortByDisable={setEnableSortByDisable}
                        showActivationCodeColumn={showActivationCodeColumn}
                        setShowActivationCodeColumn={showActivationCalculation()}
                    />

                    <div style={{
                        display: 'flex',
                        justifyContent: 'end'
                    }}>
                        <Button
                            themeColor={"primary"}
                            size={"large"}
                            fillMode={"solid"}
                            type={"button"}
                            rounded={"small"}
                            onClick={() => {
                                const hostIDType = unassigned.filter(item => item.selected)[0]['host_id_type']
                                setDetails(hostDetails[hostIDType])
                            }}
                            disabled={unassigned.filter(item => item.selected).length === 0}
                        >
                            {localization.toLanguageString(productsHostKey, mainMessages[siteLanguageDefault][productsHostKey])}
                        </Button>
                    </div>
                </>
            )}

            {Object.keys(details).length !== 0 && (
                <AssignProductsModal
                    setIsLoading={setIsLoading}
                    scrollRef={scrollRef}
                    details={details}
                    setDetails={setDetails}
                    assigned={assigned}
                    setAssigned={setAssigned}
                    unassigned={unassigned}
                    setUnassigned={setUnassigned}
                    xAuthToken={xAuthToken}
                    sortByDisableValue={sortByDisableValue}
                    setSelectHeaderCheck={setSelectHeaderCheck}
                    setEnableSortByDisable={setEnableSortByDisable}
                />
            )}
        </div>
    )
}
